import React, { useState } from "react";
import { Container, Row, Col, Form, FormGroup, Input, Button } from "reactstrap";
import Footer from "components/Footer/Footer";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    message: "Hola, me gustaría obtener información sobre tratamientos y turnos."
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsappNumber = "5492996316836";
    const message = `*Nuevo mensaje de contacto*\n\n*Nombre:* ${formData.name}\n\n*Mensaje:*\n${formData.message}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="section" id="contact" style={{paddingBottom: 0}}>
      <Container>
        <Row className="justify-content-center">
          <Col md="8" className="text-center">
            <h2 className="section-title reveal">Contactanos</h2>
            <p className="section-lead reveal">Estamos acá para ayudarte con tu salud bucal</p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="7" lg="6">
            <div className="contact-card reveal">
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Input 
                    placeholder="Tu nombre" 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-control"
                  />
                </FormGroup>
                <FormGroup>
                  <Input 
                    placeholder="Tu mensaje" 
                    type="textarea" 
                    rows="5" 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="form-control"
                  />
                </FormGroup>
                <div className="text-center">
                  <Button 
                    color="primary" 
                    type="submit"
                    className="btn-primary"
                  >
                    <i className="fab fa-whatsapp mr-2"></i>
                    Enviar por WhatsApp
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
      <div style={{marginTop: 'auto'}}>
        <Footer />
      </div>
    </div>
  );
} 